/* eslint-disable import/no-extraneous-dependencies */
import {
  createStore,
  applyMiddleware,
  combineReducers,
  compose,
} from 'redux';
import thunk from 'redux-thunk';

import createFetchReducer from './services/fetch/create-fetch.reducer';
import { reducer } from './pages/admin/users';

const rootReducer = combineReducers({
  me: createFetchReducer('ME', undefined, []),
  profile: createFetchReducer('PROFILE', undefined, {}),
  users: reducer(undefined, {}),
  addUser: createFetchReducer('ADD_USER', undefined, []),
  editUser: createFetchReducer('EDIT_USER', undefined, []),
  currentUser: createFetchReducer('GET_USER', undefined, []),
  historyUser: createFetchReducer('HISTORY_USER', undefined, []),
  parties: createFetchReducer('PARTIES', undefined, []),
  partiesName: createFetchReducer('PARTIES_NAME', undefined, []),
  currentParty: createFetchReducer('GET_PARTY', undefined, []),
  activateParty: createFetchReducer('ACTIVATE_PARTY', undefined, []),
  historyParty: createFetchReducer('HISTORY_PARTY', undefined, []),
  committees: createFetchReducer('COMMITTEES', undefined, []),
  committeesName: createFetchReducer('COMMITTEES_NAME', undefined, []),
  currentCommittee: createFetchReducer('GET_COMMITTEE', undefined, []),
  committeeMembersList: createFetchReducer('ADD_MEMBERS_COMMITTEE', undefined, []),
  committeesAddNames: createFetchReducer('COMMITTEE_ADD_USERS', undefined, []),
  historyCommittee: createFetchReducer('HISTORY_COMMITTEE', undefined, []),
});

// enable redux dev-tools
// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)));
